module.exports = __webpack_public_path__ + "img/orthese-fabrication.84eac768.jpg";